// Diagnose Mode: Standalone (Mode 1), VDR-invoked (Mode 2), and VDR multi-session (Mode 3).
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngrx/store';
import { MessageService } from 'primeng/api';
import { Button } from 'primeng/button';
import { TextareaModule } from 'primeng/textarea';
import { UserSettingService } from '../../../../core/admin-features/services/diagnosis-session/user-setting.service';
import { IUserFeedback } from '../../../../core/common/models/workflow/user-setting';
import { RootState } from '../../../../core/store/reducers/RootState.model';
import {
  selectDiagnosisId,
  selectRelatedVDRJob,
} from '../../../../core/store/workflow/selectors/workflow.selectors';

@Component({
  selector: 'app-mail-box',
  imports: [Button, TextareaModule, ReactiveFormsModule],
  templateUrl: './mail-box.component.html',
  styleUrl: './mail-box.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MailBoxComponent {
  #store = inject(Store<RootState>);
  readonly #fb = inject(FormBuilder);
  toastr = inject(MessageService);
  readonly #userSettingService = inject(UserSettingService);
  vdrJob = toSignal(this.#store.select(selectRelatedVDRJob));
  diagnosisId = toSignal(this.#store.select(selectDiagnosisId));

  form: FormGroup;
  isExpanded = false;

  constructor() {
    this.form = this.#fb.group({
      issueDescription: [''],
    });
  }

  toggleExpanded() {
    this.isExpanded = !this.isExpanded;
  }

  onSubmit() {
    const userFeeback: IUserFeedback = {
      message: this.form.value.issueDescription,
      cc: '',
      sessionId: this.diagnosisId() || '--',
      jobId: this.vdrJob()?.jobId || '--',
      projectName: this.vdrJob()?.projectName || '--',
      projectId: this.vdrJob()?.projectId || '--',
      plo_so: this.vdrJob()?.ploNumber || this.vdrJob()?.soNumber || '--',
    };

    this.#userSettingService
      .sendFeedback(userFeeback)
      .subscribe((isSuccess) => {
        if (isSuccess) {
          this.toastr.add({
            severity: 'success',
            summary: 'Send Mail Successfully!',
            detail: 'Your issue have been submitted successfully.',
            closable: true,
          });
          this.form.reset();
          this.isExpanded = false;
        } else {
          this.toastr.add({
            severity: 'error',
            summary: 'Send Mail Failed!',
            detail:
              'Your issue could not be submitted. Please try again later.',
            closable: true,
          });
        }
      });
  }
}
